<template>
    <div class="s-loading">

    </div>
</template>
<script>
import axios from 'axios'
import {safeLandingPath} from '@/navigation-context'
export default{
    created() {
        // this.getAllSMS();
        this.chgetCookies();
    },
    methods: {
        async chgetCookies() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'check');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[all]', 'justcheck');
            try {
                const {data: res} = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                if (!res || !res.error || Number(res.error.number) !== 200 || !res.results || !res.results.data) {
                    this.connected = false;
                    if (this.$route.name !== 'Login') await this.$router.push({name: 'Login'});
                    return false;
                }
                this.$store.state.group_id = res.results.data.group_id;
                this.connected = true;
                if (['Login', 'Loading'].includes(this.$route.name)) {
                    const path = Number(this.$store.state.group_id) === 4 ? '/vendors/vendor-index/' : safeLandingPath(localStorage.getItem('redirectURl'));
                    if (this.$route.path !== path) await this.$router.push({path});
                }
                return true;
            } catch (error) {
                this.connected = false;
                if (this.$route.name !== 'Login') await this.$router.push({name: 'Login'});
                return false;
            }
        },
        getAllSMS(){
            const post = new FormData();
            post.append("type","getSMSTemp");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[all]",'123')
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((res) => {
                // // console.log(res.data);
                this.$store.state.smsTemp = res.data.results.data;
            })
        },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    },
}
</script>
<style>
.s-loading{
    position:fixed;
    top:0;
    left:0;
    bottom: 0;
    right: 0;
    background: #00000055;
}
</style>